import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { styledWithTheme } from "../context";
import { Row } from "../layout";
import { opacify } from "../utils";
export var ShadowPosition;

(function (ShadowPosition) {
  ShadowPosition["Top"] = "top";
  ShadowPosition["Bottom"] = "bottom";
})(ShadowPosition || (ShadowPosition = {}));

var RowWithShadow = styledWithTheme(Row)(function (_ref) {
  var theme = _ref.theme,
      hasShadow = _ref.hasShadow,
      shadowPosition = _ref.shadowPosition;
  var isTop = shadowPosition === ShadowPosition.Top;
  var NEUTRAL90 = theme.selectors.color('neutral90');
  var transparent = opacify(NEUTRAL90, 0);
  var shadowColor = opacify(NEUTRAL90, 0.2);
  var gradient = isTop ? "linear-gradient(".concat(transparent, ", ").concat(shadowColor, ")") : "linear-gradient(".concat(shadowColor, ", ").concat(transparent, ")");
  return {
    position: 'relative',
    ':before': {
      // The shadow won't appear unless the element has content, and
      // the value needs to include quotes so that they are applied in
      // the actual CSS - `content: ' '` would result in invalid CSS
      // because the string wouldn't be quoted in the DOM.
      content: '" "',
      transition: 'opacity 0.3s',
      opacity: hasShadow ? 1 : 0,
      position: 'absolute',
      top: isTop ? -5 : undefined,
      bottom: isTop ? undefined : -5,
      height: 5,
      left: 0,
      right: 0,
      background: gradient
    }
  };
});
RowWithShadow.displayName = 'RowWithShadow';
RowWithShadow.defaultProps = _objectSpread({}, Row.defaultProps);
export default RowWithShadow;